import * as Yup from 'yup';

export const authorStepSchema = Yup.object({
    authorId: Yup.string()
        .required('Wybierz autora'),

    authorName: Yup.string()
        .when('authorId', {
            is: (val: string) => !!val,
            then: (schema) => schema.required('Nazwa autora jest wymagana'),
            otherwise: (schema) => schema.nullable().optional(),
        }),
});
